import axios from 'axios';
import configs from "../../../configs/config";
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState,useMemo,useRef} from 'react';
import 'reactflow/dist/style.css';
import CustomSelect from '../../common/customSelect/CustomSelect';
import CustomFormLabel from '../../common/form-label/CustomFormLabel ';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../../redux/reducers/rootReducers';
import { getPrioritiesWithTicketTypeKey } from '../../helpers/helperFunctions';
import { debounce } from 'lodash';
import { unsetNodeErrors } from '../../../redux/actions/Workflow/workflow';
import CategorySelectField from '../../../pages/new-ticket/CategorySelectField';
import { getCategoryNode } from '../../../redux/actions/SystemManagement/AddCategory';
import SearchableDropdown from '../../common2/SearchableDropdown';
const minSearchChars = 3
export interface generateNodeValuesResult {
  agentVal:any;
  groupVal:any;
  statusVal:any;
  emailTemplateVal:any;
  ticketTypeVal:any;
  priorityVal:any;
}
export const defaultAgents = [{ id:-1, value:-1, label:"{RoundRobin}" }, {id: -2, value:-2, label:"{Owner}" }];
export const generateNodeValues:any = (allResponses:any,task:any={}) =>{
  // console.log("allResponses***",allResponses)
  // console.log("task****",task)
  const {AgentsList=[],ticketStatus=[],priorities=[],groups=[],templatesList=[],TicketTypes=[],ticketTaskStatus=[],formattedOrg,contactMapData} = allResponses || {};
  const {statusId,groupId,agentId,dynamicAgent,ticketTypeId,priorityId,emailTemplateId,category,categoryId,ContactId,SecondaryContactId,thirdPartyOrgId,contact,secondaryContact} = task || {};
  const tempObj = {
    agentVal : [...defaultAgents,...AgentsList].find((i:any)=>i.id===agentId || (agentId === 0 && i.label === dynamicAgent)) || null,
    groupVal :  groups.find((i:any)=>i.id===groupId) || null,
    statusVal :  ticketStatus.find((i:any)=>i.id===statusId) || ticketTaskStatus.find((i:any)=>i.id===statusId)  || null,
    emailTemplateVal :  templatesList.find((i:any)=>i.id===emailTemplateId) || null,
    ticketTypeVal :  TicketTypes.find((i:any)=>i.id===ticketTypeId) || null,
    priorityVal :  priorities.find((i:any)=>i.id===priorityId) || null,
    categoryVal : category ? {...category, label : category.name, value : category.id} : null,
    categoryId,
   contactId:ContactId ? contactMapData.get(String(ContactId)) : contact ? {...contact, label : contact.name, value : contact.id} : [],
   secondaryContactId:SecondaryContactId ? contactMapData.get(String(SecondaryContactId)) : secondaryContact ? {...secondaryContact, label : secondaryContact.name, value : secondaryContact.id} : [],
   thirdPartyOrgId:thirdPartyOrgId  ? formattedOrg?.find((i:any) => i.value == thirdPartyOrgId) : []
  }
  // console.log("tempObj",tempObj)
  return tempObj;
}

const NodeActionsForm:any = (props:any) => {
    const allResponses = useSelector((state:IState)=>state?.TicketsReducer?.allResponses)
    const templatesList = useSelector((state: IState) => state?.EmailTemplatesReducer?.AllEmailTemplates);
     const activeEmailTemplates = useMemo(() => { 
      return templatesList.filter((temp:any) => temp.isActive)},[templatesList])
    const errors = useSelector((state:IState)=>state?.WorkflowReducer?.errors)
    const allOrganisationList = useSelector((state: IState) => state.DepartmentReducer.OrganisationList)
    // console.log("allOrganisationList_",allOrganisationList)
    const {nodeConfig} = props;
   
    // console.log("activeThirdPartyOrg_",activeThirdPartyOrg)
    const dispatch = useDispatch();
  
    // console.log("nodeconfig__",nodeConfig)
    const [fields, setfields] = useState(`${nodeConfig?.actions || ""}`)

    const [priorityByIdTTID,setPriorityByIdTTID] = useState<any>(getPrioritiesWithTicketTypeKey(allResponses?.priorities))

    const controllerRef = useRef<AbortController | null>(null);
    const [agentsList, setAgentsList] = useState<any>([]);
    const [priorityList, setPriorityList] = useState<any>([]);
    const [agentVal, setAgentVal] = useState<any>(nodeConfig?.dataToPrefill?.agentVal || null);
    const [groupVal, setGroupVal] = useState<any>(nodeConfig?.dataToPrefill?.groupVal || null);
    const [statusVal, setStatusVal] = useState<any>(nodeConfig?.dataToPrefill?.statusVal || null);
    const [emailTemplateVal, setEmailTemplateVal] = useState<any>(nodeConfig?.dataToPrefill?.emailTemplateVal || null);
    const [ticketTypeVal, setTicketTypeVal] = useState<any>(nodeConfig?.dataToPrefill?.ticketTypeVal || null);
    const [priorityVal, setPriorityVal] = useState<any>(nodeConfig?.dataToPrefill?.priorityVal || null);
    const [categoryVal, setCategoryVal] = useState<any>(nodeConfig?.dataToPrefill?.categoryVal || null);
    const [thirdPartyOrg,setThirdPartyOrg] = useState<any>(nodeConfig?.dataToPrefill?.thirdPartyOrgId || null);
    const [ContactId,setContactId] = useState<any>(nodeConfig?.dataToPrefill?.contactId || null);
    const [SecondaryContactId,setSecondaryContactId] = useState<any>(nodeConfig?.dataToPrefill?.secondaryContactId || null);
    const [workflowContacts, setWorkflowContacts] = useState<any>([])
    const [activeDropdown, setActiveDropdown] = useState<"primary" | "secondary" | null>(null);
    const [orgList,setOrgList] = useState<any>([])
    const primaryOptions = useMemo(() => {
      if (activeDropdown !== "primary") return [];
    return workflowContacts?.filter(
      (item:any) => item.value !== SecondaryContactId?.value
    );
    }, [workflowContacts, SecondaryContactId]);
    // console.log("Primary contact",primaryOptions)
    const secondaryOptions = useMemo(() => {
       if (activeDropdown !== "secondary") return []
      return workflowContacts?.filter(
        (item:any) => item.value !== ContactId?.value
      );
    }, [workflowContacts, ContactId]);

 const activeThirdPartyOrg = useMemo(() => {
      let filteredOrg = allOrganisationList.filter((org:any) => org.isActive && org.isThirdParty)
      return filteredOrg.map((data:any) => ({
       label: data.name,
        value: data.id,
        ...data,
      }))
    },[allOrganisationList])
 const getInput = (value: string) => {
    if (!value || value.length < minSearchChars) return;

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;

    axios.get(
      `${configs.BASE_URL}/Contacts/active/byname?searchName=${value}`
    )
      .then((response: any) => {
        // console.log("new Data", response?.data)
        setWorkflowContacts(response?.data);
      })
      .catch((e:any) => { 
        // console.error(e)
      });
  }

  const getOrg = (value:string) => {
    if (!value || value.length < minSearchChars) return;
    
        if (controllerRef.current) {
          controllerRef.current.abort();
        }
    
        const controller = new AbortController();
        controllerRef.current = controller;
    
        axios.get(
          `${configs.BASE_URL}/ContactOrganisation?search=${value}&page=1&count=50&isActive=true&isThirdParty=true`
        )
          .then((response: any) => {
            // console.log("new org", response?.data);
            let processed = response?.data.map((org:any) => ({
              label:org?.name,
              value:org?.id,
              ...org
            }))
            setOrgList(processed);
          })
          .catch((e:any) => { 
            // console.error(e)
          });
  }

useEffect(() => {
  if(nodeConfig?.dataToPrefill?.thirdPartyOrgId && activeThirdPartyOrg?.length){
    const selected = activeThirdPartyOrg.find(
      (org:any) => org.value === nodeConfig.dataToPrefill.thirdPartyOrgId.value
    );
    if(selected){
      setThirdPartyOrg(selected);
    }
  }
},[activeThirdPartyOrg,nodeConfig]);

useEffect(() => {
  if(nodeConfig?.dataToPrefill?.contactId && workflowContacts?.length){
    const selectedPrimary = workflowContacts.find(
      (c:any)=>c.value === nodeConfig.dataToPrefill.contactId.value
    );

    if(selectedPrimary){
      setContactId(selectedPrimary);
    }
  }

  if(nodeConfig?.dataToPrefill?.secondaryContactId && workflowContacts?.length){

    const selectedSecondary = workflowContacts.find(
      (c:any)=>c.value === nodeConfig.dataToPrefill.secondaryContactId.value
    );
    if(selectedSecondary){
      setSecondaryContactId(selectedSecondary);
    }
  }

},[workflowContacts,nodeConfig]);

    useEffect(()=>{
      if(nodeConfig?.workflowNodeTaskList?.[0]){
        setPriorityList(priorityByIdTTID?.[ticketTypeVal?.id] || [])
        setAgentsList([...defaultAgents, ...(nodeConfig?.dataToPrefill?.groupVal?.agentsList || [])]);
      } 
    },[nodeConfig])
    
    useEffect(()=>{
      const {category , categoryId} = nodeConfig?.dataToPrefill
       if(!category && categoryId){
          getCategoryNode(categoryId).then((res:any)=>{
            setCategoryVal(res);
        });
      }
    },[])

    const ticketTypeHandler = (val:any) =>{
        setTicketTypeVal(val)
        setPriorityVal(null)
        setPriorityList(priorityByIdTTID?.[val?.id] || [])
        unsetError("hasActionError");
    }
    const groupHandler = (val:any) =>{
        setGroupVal(val)
        setAgentsList([...defaultAgents, ...(val?.agentsList || [])]);
        unsetError("hasActionError")
        setAgentVal(null)
    }
    const unsetError = debounce((name:string="")=>{
      if(errors?.[name]){
        dispatch(unsetNodeErrors([name]))
      }
    },200)

    //This is to filter out the "Delete" status from the dropdown as per the requirement.
    const filteredTicketStatus = useMemo(() => {
      return (allResponses?.ticketStatus || []).filter(
        (s:any) => s?.name?.toLowerCase() !== "delete"
      );
    }, [allResponses?.ticketStatus]);
    return (
        <>      
            <Grid
              container
              spacing={1}
            >
              <Grid item md={12}>
                {errors?.hasActionError && <Typography component={"span"} className='txt-danger'>Please choose any one field to continue!</Typography>}
              </Grid>
               {fields?.includes('ContactId') &&
                <Grid item xs={12} md={4}>
  
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Primary Contact"}
                      isMandotary={false}
                    />
                  <SearchableDropdown
                    minSearchChars={minSearchChars}
                    isOpen={false}
                    placeholder="Select Primary Contact"
                    width={"100%"}
                    name="ContactId"
                    isColor={false}
                    isDisabled={false}
                    isError={false}
                    defaultValue={ContactId}
                    options={primaryOptions}
                    onFocus={() => setActiveDropdown("primary")}
                    handleChange={(e: any) => {
                      setContactId(e);
                      unsetError("hasActionError");
                    }}
                    helperText={""}
                    customClassNames=""
                    getInput={getInput}
                  />
                  <span style={{ fontSize: "12px", color: "#c8c8c8" }}>
                    * You need at least {minSearchChars} characters to search
                  </span>
                  </Box>
                </Grid>
              }
               {fields?.includes('SecondaryContactId') &&
                <Grid item xs={12} md={4}>
  
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Secondary Contact"}
                      isMandotary={false}
                    />
                   
                    <SearchableDropdown
                      minSearchChars={minSearchChars}
                      isOpen={false}
                      placeholder="Select Secondary Contact"
                      width={"100%"}
                      name="SecondaryContactId"
                      isColor={false}
                      isDisabled={false}
                      isError={false}
                      defaultValue={SecondaryContactId}
                      options={secondaryOptions}
                      onFocus={() => setActiveDropdown("secondary")}
                      handleChange={(e: any) => {
                        setSecondaryContactId(e);
                        unsetError("hasActionError");
                      }}
                      isMulti={false}
                      helperText={""}
                      customClassNames=""
                      getInput={getInput}
                    />
                    <span style={{ fontSize: "12px", color: "#c8c8c8" }}>
                      * You need at least {minSearchChars} characters to search
                    </span>
                  </Box>
                </Grid>
              }
               {fields?.includes('ticketTypeId') &&
                <Grid item xs={12} md={4}>
                    <Box className="">
                      <CustomFormLabel
                        labelName={"Ticket Type"}
                        isMandotary={false}
                      />
                      <CustomSelect
                        isOpen={false}
                        placeholder="Select Ticket Type"
                        width={"100%"}
                        name="ticketTypeId"
                        isColor={false}
                        isDisabled={false}
                        isError={false}
                        defaultValue={ticketTypeVal}
                        options={allResponses?.TicketTypes}
                        handleChange={ticketTypeHandler}
                        isMulti={false}
                        helperText={""}
                        customClassNames=""
                      />
                    </Box>
                </Grid>
              }
               {fields?.includes('categoryId') &&
                <Grid item xs={12} md={4}>
                  <CategorySelectField
                    ticketTypeId={ticketTypeVal?.id || null}
                    isMandotary={false} 
                    initVal={categoryVal}
                  />
                  <Typography>Choose Ticket Type before choosing a Category! </Typography>
                </Grid>
              }
              {fields?.includes('priorityId') &&
                <Grid item xs={12} md={4}>
  
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Priority"}
                      isMandotary={false}
                    />
                    <CustomSelect
                      isOpen={false}
                      placeholder="Select Priority"
                      width={"100%"}
                      name="priorityId"
                      isColor={false}
                      isDisabled={false}
                      isError={false}
                      defaultValue={priorityVal}
                      options={priorityList}
                      handleChange={(e:any)=>{
                        setPriorityVal(e);
                        unsetError("hasActionError");
                      }}
                      isMulti={false}
                      helperText={""}
                      customClassNames=""
                    />
                    <Typography>Choose Ticket Type before choosing a Priority! </Typography>
                  </Box>
                </Grid>
              }
              {fields?.includes('statusId') &&
                <Grid item xs={12} md={4}>
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Status"}
                      isMandotary={false}
                    />
                    <CustomSelect
                      isOpen={false}
                      placeholder="Select Status"
                      width={"100%"}
                      name="statusId"
                      isColor={false}
                      isDisabled={false}
                      isError={false}
                      defaultValue={statusVal}
                      options={nodeConfig?.apiLabel === "ManagerApproval" || nodeConfig?.apiLabel === "AssignAgent"
                        ? allResponses?.ticketTaskStatus
                        : filteredTicketStatus}
                      handleChange={(e:any)=>{
                        setStatusVal(e);
                        unsetError("hasActionError")
                      }}
                      isMulti={false}
                      helperText={""}
                      customClassNames=""
                    />
                  </Box>
                </Grid>
              }
               {fields?.includes('thirdPartyOrgId') &&
                <Grid item xs={12} md={4}>
  
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Third Party Organisation"}
                      isMandotary={false}
                    />
                    <SearchableDropdown
                    minSearchChars={2}
                    isOpen={false}
                    placeholder="Select Third Party"
                    width={"100%"}
                    name="thirdPartyOrgId"
                    isColor={false}
                    isDisabled={false}
                    isError={false}
                    defaultValue={thirdPartyOrg}
                    options={orgList}
                    handleChange={(e: any) => {
                      setThirdPartyOrg(e);
                      unsetError("hasActionError");
                    }}
                    helperText={""}
                    customClassNames=""
                    getInput={getOrg}
                  />
                  <span style={{ fontSize: "12px", color: "#c8c8c8" }}>
                    * You need at least {minSearchChars} characters to search
                  </span>
                  </Box>
                </Grid>
             } 
              {fields?.includes('groupId') &&
                <Grid item xs={12} md={4}>
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Group"}
                      isMandotary={false}
                    />
                    <CustomSelect
                      isOpen={false}
                      placeholder="Select Group"
                      width={"100%"}
                      name="groupId"
                      isColor={false}
                      isDisabled={false}
                      isError={false}
                      defaultValue={groupVal}
                      options={allResponses?.groups}
                      handleChange={groupHandler}
                      isMulti={false}
                      helperText={""}
                      customClassNames=""
                    />
                  </Box>
                </Grid>
              }
              {fields?.includes('agentId') &&
                <Grid item xs={12} md={4}>
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Owner"}
                      isMandotary={false}
                    />
                    <CustomSelect
                      isOpen={false}
                      placeholder="Select Owner"
                      width={"100%"}
                      name="agentId"
                      isColor={false}
                      isDisabled={false}
                      isError={false}
                      defaultValue={agentVal}
                      options={agentsList}
                      handleChange={(e:any)=>{
                        setAgentVal(e);
                        unsetError("hasActionError")
                      }}
                      isMulti={false}
                      helperText={""}
                      customClassNames=""
                    />
                      <Typography>Choose Group before choosing an Owner! </Typography>
                  </Box>
                </Grid>
              }
             
             
              
             
              {fields?.includes('emailTemplateId') &&
              <Grid item xs={12} md={4}>
                  <Box className="">
                    <CustomFormLabel
                      labelName={"Email Template"}
                      isMandotary={false}
                    />
                    <CustomSelect
                      isOpen={false}
                      placeholder="Select Email Template"
                      width={"100%"}
                      name="emailTemplateId"
                      isColor={false}
                      isDisabled={false}
                      isError={false}
                      defaultValue={emailTemplateVal}
                      options={activeEmailTemplates || []}
                      handleChange={(e:any)=>{
                        setEmailTemplateVal(e)
                        unsetError("hasActionError")
                      }}
                      isMulti={false}
                      helperText={""}
                      customClassNames=""
                    />
                    {emailTemplateVal?.from &&
                      <Typography >
                        From : {emailTemplateVal?.from}
                      </Typography>
                    }
                  </Box>
              </Grid>}
            </Grid>
        </>)
}
export default NodeActionsForm;